import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SecretLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formRef = useRef(null);

  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("nb_token", res.data.token);
      localStorage.setItem("nb_user", JSON.stringify(res.data.user));
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Anmeldung fehlgeschlagen");
    }
    setLoading(false);
  };

  return (
    <div className="py-12 md:py-0 md:min-h-screen bg-background flex items-center justify-center px-4" data-testid="secret-login-page">
      <div ref={formRef} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-6 h-6 text-primary" />
          </div>
          <h1 className="text-2xl font-bold uppercase tracking-tight" style={{ fontFamily: 'Oswald' }}>
            Admin Login
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Ninersbillard Verwaltung</p>
        </div>

        <form onSubmit={handleLogin} className="bg-card border border-white/5 p-6 space-y-4">
          <div>
            <Label htmlFor="username" className="text-sm font-medium">Benutzername</Label>
            <Input id="username" value={username} onChange={e => setUsername(e.target.value)}
              className="mt-1 bg-input/50 border-white/10 focus:border-primary rounded-none"
              placeholder="admin" autoComplete="username" data-testid="login-username" />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-medium">Passwort</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="mt-1 bg-input/50 border-white/10 focus:border-primary rounded-none"
              placeholder="********" autoComplete="current-password" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full px-6 py-3 bg-primary text-primary-foreground font-bold uppercase tracking-wider text-sm hover:-translate-y-1 transition-transform duration-200 disabled:opacity-50">
            {loading ? "Wird angemeldet..." : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
